export const OPEN_LOAN_TOOLTIP = 'Open loan application';
